<template>
  <div>
    <h1>{{ event.title }}</h1>
    <p>{{ event.time }} on {{ event.date }} @ {{ event.location }}</p>
    <p>{{ event.description }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { TEvent } from "@/Types";
import EventService from "@/Services/EventService";

export default defineComponent({
  name: "EventDetails",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const event = ref({} as TEvent);

    EventService.getEvent(props.id)
      .then((response) => {
        event.value = response.data;
      })
      .catch((ex) => console.error(ex));

    return {
      event,
    };
  },
});
</script>

<style scoped></style>
